const IsFetchingAction = ({ setIsFetching, IsFetching }) => {
  setTimeout(() => {
    setIsFetching(!IsFetching);
  }, 10000);
};

export default IsFetchingAction;
